/**
 * Memoket Enhanced Analytics Module
 * 增强版分析追踪 - 追踪用户行为帮助优化内容
 * 
 * 追踪内容：
 * 1. Hero 轮播图 - 哪张图片更吸引用户
 * 2. 视频播放 - 播放进度和完成率
 * 3. Section 停留时间 - 用户在哪个区域停留最久
 * 4. Tab/轮播切换 - 用户对哪些内容感兴趣
 * 5. FAQ 展开 - 用户关心哪些问题
 * 6. 滚动深度 - 用户浏览到哪里
 * 
 * @version 2.0.0
 */

(function() {
  'use strict';

  var EnhancedAnalytics = {
    config: {
      debug: false,
      enableTimeEvents: false,
      enablePtengine: false,
      // Section 名称映射（用于更友好的报告）
      sectionNames: {
        'hero-a': 'Hero A',
        'hero-b': 'Hero B',
        'session-a-02': '产品视频',
        'session-a03': 'Timeline 时间线',
        'session-a04': 'Capture/Connect/Create',
        'session-a05': '4种佩戴方式',
        'session-a06': 'Structured Understanding',
        'session-a07': 'Memory-Powered AI',
        'session-a08': 'AI 应用场景轮播',
        'session-a09': 'Daily Tools 集成',
        'session-bwe-s1': 'BWE Hero',
        'session-c02': 'BWE Countdown',
        'session-bwe-s2': 'BWE Co-Founder Video',
        'session-bwe-s3': 'BWE Founding Member Benefits',
        'session-bwe-s4': 'BWE Program Steps',
        'session-bwe-s5': 'BWE Ideal Users',
        'session-bwe-s6': 'BWE Feedback Invite',
        'session-bwe-s7': 'BWE FAQ',
        'team': '团队介绍',
        'faq': 'FAQ 常见问题',
        'footer-subscribe': '底部订阅'
      }
    },

    // 存储追踪数据
    data: {
      heroSlideViews: {},      // 轮播图各 slide 浏览时间
      sectionTimes: {},        // 各 section 停留时间
      videoProgress: {},       // 视频播放进度
      tabClicks: {},           // Tab 点击统计
      faqExpands: {},          // FAQ 展开统计
      sessionStart: Date.now() // 会话开始时间
    },

    /**
     * 初始化
     */
    init: function() {
      var self = this;
      
      // 等待 DOM 加载完成
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          self.setupTracking();
        });
      } else {
        this.setupTracking();
      }
      
      // 页面离开时发送汇总数据
      window.addEventListener('beforeunload', function() {
        self.sendSummaryData();
      });
      
      // visibilitychange 时也发送（移动端更可靠）
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'hidden') {
          self.sendSummaryData();
        }
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Initialized');
      }
    },

    /**
     * 设置所有追踪
     */
    setupTracking: function() {
      this.trackHeroCarousel();
      this.trackSectionA08Carousel();
      this.trackSectionA05Tabs();
      this.trackVideoPlayback();
      this.trackFAQInteraction();
      this.trackEnhancedSectionTime();
      this.trackScrollMilestones();
    },

    /**
     * 发送事件到 Ptengine
     */
    track: function(eventName, properties) {
      properties = properties || {};
      properties.timestamp = new Date().toISOString();
      properties.page_url = window.location.href;

      // Auto-attach A/B test variant info to all events
      if (window.__MEMOKET_AB) {
        for (var testKey in window.__MEMOKET_AB) {
          if (window.__MEMOKET_AB.hasOwnProperty(testKey) && testKey !== 'currentHeroVariant') {
            properties['ab_' + testKey] = window.__MEMOKET_AB[testKey];
          }
        }
      }
      
      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Track:', eventName, properties);
      }

      // 统一通过 MemoketAnalytics.track() 发送到所有平台（Ptengine / GA4 / Klaviyo / Meta）
      // 不要在这里直接调用 ptengine.track()，否则会导致 Ptengine 收到双重事件
      if (window.MemoketAnalytics && window.MemoketAnalytics.track) {
        window.MemoketAnalytics.track(eventName, properties);
      }
    },

    /**
     * 1. Hero 轮播图追踪
     * 追踪用户在每张图片上停留的时间
     */
    trackHeroCarousel: function() {
      var self = this;
      var heroSection = document.querySelector('.hero-a');
      if (!heroSection) return;

      var currentSlide = 1;
      var slideStartTime = Date.now();
      var totalSlides = heroSection.querySelectorAll('.hero-a__slide:not(.hero-a__slide--clone)').length;

      // 初始化每个 slide 的浏览时间
      for (var i = 1; i <= totalSlides; i++) {
        this.data.heroSlideViews['slide_' + i] = 0;
      }

      // 监听 slide 变化
      var slidesContainer = heroSection.querySelector('.hero-a__slides');
      if (slidesContainer) {
        // 使用 MutationObserver 监听 transform 变化
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'style') {
              var transform = slidesContainer.style.transform;
              var match = transform.match(/translateX\(-?(\d+)%\)/);
              if (match) {
                var percentage = parseInt(match[1]);
                var newSlide = Math.round(percentage / 100);
                // 处理克隆 slide 的情况
                if (newSlide < 1) newSlide = totalSlides;
                if (newSlide > totalSlides) newSlide = 1;
                
                if (newSlide !== currentSlide) {
                  // 记录上一个 slide 的时间
                  var duration = Date.now() - slideStartTime;
                  self.data.heroSlideViews['slide_' + currentSlide] += duration;
                  
                  // 发送 slide 切换事件
                  self.track('hero_slide_change', {
                    from_slide: currentSlide,
                    to_slide: newSlide,
                    view_duration_ms: duration,
                    interaction_type: 'auto_or_manual'
                  });
                  
                  currentSlide = newSlide;
                  slideStartTime = Date.now();
                }
              }
            }
          });
        });

        observer.observe(slidesContainer, { attributes: true });
      }

      // 追踪用户手动切换（点击箭头或滑动）
      var prevBtn = heroSection.querySelector('.hero-a__nav-btn--prev');
      var nextBtn = heroSection.querySelector('.hero-a__nav-btn--next');
      
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          self.track('hero_slide_interaction', {
            action: 'prev_click',
            current_slide: currentSlide
          });
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          self.track('hero_slide_interaction', {
            action: 'next_click',
            current_slide: currentSlide
          });
        });
      }

      // 追踪滑动
      heroSection.addEventListener('touchend', function() {
        self.track('hero_slide_interaction', {
          action: 'swipe',
          current_slide: currentSlide
        });
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Hero carousel tracking setup, slides:', totalSlides);
      }
    },

    /**
     * 2. Session A08 轮播图追踪（AI 应用场景）
     */
    trackSectionA08Carousel: function() {
      var self = this;
      var section = document.querySelector('.session-a08');
      if (!section) return;

      var tabs = section.querySelectorAll('.session-a08__tab');
      var tabLabels = [];
      
      tabs.forEach(function(tab, index) {
        var label = tab.textContent.trim();
        tabLabels.push(label);
        
        tab.addEventListener('click', function() {
          self.track('carousel_tab_click', {
            section: 'session-a08',
            section_name: 'AI 应用场景',
            tab_index: index,
            tab_label: label
          });
          
          // 记录点击次数
          if (!self.data.tabClicks['session-a08']) {
            self.data.tabClicks['session-a08'] = {};
          }
          self.data.tabClicks['session-a08'][label] = (self.data.tabClicks['session-a08'][label] || 0) + 1;
        });
      });

      // 追踪箭头点击
      var prevBtn = section.querySelector('.session-a08__arrow--prev');
      var nextBtn = section.querySelector('.session-a08__arrow--next');
      
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          self.track('carousel_navigation', {
            section: 'session-a08',
            action: 'prev'
          });
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          self.track('carousel_navigation', {
            section: 'session-a08',
            action: 'next'
          });
        });
      }

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Session A08 carousel tracking setup, tabs:', tabLabels);
      }
    },

    /**
     * 3. Session A05 Tab 追踪（4种佩戴方式）
     */
    trackSectionA05Tabs: function() {
      var self = this;
      var section = document.querySelector('.session-a05, [data-section-type="session-a05"]');
      if (!section) return;

      var tabs = section.querySelectorAll('[data-tab], .session-a05__tab');
      
      tabs.forEach(function(tab, index) {
        var label = tab.textContent.trim();
        
        tab.addEventListener('click', function() {
          self.track('wearing_style_tab_click', {
            section: 'session-a05',
            section_name: '4种佩戴方式',
            tab_index: index,
            wearing_style: label
          });
          
          // 记录点击次数
          if (!self.data.tabClicks['session-a05']) {
            self.data.tabClicks['session-a05'] = {};
          }
          self.data.tabClicks['session-a05'][label] = (self.data.tabClicks['session-a05'][label] || 0) + 1;
        });
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Session A05 tabs tracking setup');
      }
    },

    /**
     * 4. 视频播放追踪
     */
    trackVideoPlayback: function() {
      var self = this;
      var videos = document.querySelectorAll('video');
      
      videos.forEach(function(video, index) {
        var videoId = video.id || video.closest('[data-section-type]')?.dataset.sectionType || 'video_' + index;
        var progressMilestones = [25, 50, 75, 90, 100];
        var trackedMilestones = {};
        var playStartTime = null;

        // 播放开始
        video.addEventListener('play', function() {
          playStartTime = Date.now();
          self.track('video_play', {
            video_id: videoId,
            current_time: Math.round(video.currentTime),
            duration: Math.round(video.duration) || 0
          });
        });

        // 暂停
        video.addEventListener('pause', function() {
          var watchDuration = playStartTime ? Date.now() - playStartTime : 0;
          self.track('video_pause', {
            video_id: videoId,
            current_time: Math.round(video.currentTime),
            duration: Math.round(video.duration) || 0,
            watch_duration_ms: watchDuration
          });
          playStartTime = null;
        });

        // 进度追踪
        video.addEventListener('timeupdate', function() {
          if (!video.duration) return;
          
          var progress = Math.round((video.currentTime / video.duration) * 100);
          
          progressMilestones.forEach(function(milestone) {
            if (progress >= milestone && !trackedMilestones[milestone]) {
              trackedMilestones[milestone] = true;
              self.track('video_progress', {
                video_id: videoId,
                progress_percent: milestone,
                current_time: Math.round(video.currentTime),
                duration: Math.round(video.duration)
              });
            }
          });
        });

        // 播放完成
        video.addEventListener('ended', function() {
          self.track('video_complete', {
            video_id: videoId,
            duration: Math.round(video.duration) || 0
          });
        });
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Video tracking setup, videos found:', videos.length);
      }
    },

    /**
     * 5. FAQ 展开追踪
     */
    trackFAQInteraction: function() {
      var self = this;
      var faqItems = document.querySelectorAll('[data-faq-item]');
      
      faqItems.forEach(function(item, index) {
        var trigger = item.querySelector('[data-faq-trigger]');
        var questionText = trigger ? trigger.textContent.trim().substring(0, 100) : 'Question ' + (index + 1);
        
        if (trigger) {
          trigger.addEventListener('click', function() {
            var isExpanding = trigger.getAttribute('aria-expanded') !== 'true';
            
            self.track('faq_interaction', {
              action: isExpanding ? 'expand' : 'collapse',
              question_index: index + 1,
              question_text: questionText
            });
            
            // 记录展开次数
            if (isExpanding) {
              self.data.faqExpands[questionText] = (self.data.faqExpands[questionText] || 0) + 1;
            }
          });
        }
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] FAQ tracking setup, items found:', faqItems.length);
      }
    },

    /**
     * 6. 增强的 Section 停留时间追踪
     */
    trackEnhancedSectionTime: function() {
      var self = this;
      var sections = document.querySelectorAll('[data-section], [data-section-type]');
      
      if (!('IntersectionObserver' in window)) return;

      sections.forEach(function(section) {
        var sectionId = section.dataset.section || section.dataset.sectionType || section.id;
        if (!sectionId) return;
        
        var sectionName = self.config.sectionNames[sectionId] || sectionId;
        var viewStartTime = null;
        var totalViewTime = 0;
        var hasBeenViewed = false;

        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              // 进入视口
              viewStartTime = Date.now();
              
              if (!hasBeenViewed) {
                hasBeenViewed = true;
                self.track('section_first_view', {
                  section_id: sectionId,
                  section_name: sectionName,
                  scroll_depth_percent: Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100)
                });
              }
            } else if (viewStartTime) {
              // 离开视口
              var viewDuration = Date.now() - viewStartTime;
              totalViewTime += viewDuration;
              
              // 存储数据
              self.data.sectionTimes[sectionId] = totalViewTime;
              
              // 如果停留时间超过 3 秒，发送事件
              if (viewDuration > 3000 && self.config.enableTimeEvents) {
                self.track('section_engagement', {
                  section_id: sectionId,
                  section_name: sectionName,
                  view_duration_ms: viewDuration,
                  total_view_time_ms: totalViewTime
                });
              }
              
              viewStartTime = null;
            }
          });
        }, { threshold: 0.3 });

        observer.observe(section);
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Enhanced section tracking setup, sections:', sections.length);
      }
    },

    /**
     * 7. 滚动里程碑追踪
     */
    trackScrollMilestones: function() {
      var self = this;
      var milestones = [10, 25, 50, 75, 90, 100];
      var trackedMilestones = {};
      var maxScrollDepth = 0;

      var throttle = function(func, limit) {
        var inThrottle;
        return function() {
          var args = arguments;
          var context = this;
          if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function() {
              inThrottle = false;
            }, limit);
          }
        };
      };

      var trackScroll = throttle(function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var scrollPercent = Math.round((scrollTop / docHeight) * 100);

        // 更新最大滚动深度
        if (scrollPercent > maxScrollDepth) {
          maxScrollDepth = scrollPercent;
        }

        // 追踪里程碑
        milestones.forEach(function(milestone) {
          if (scrollPercent >= milestone && !trackedMilestones[milestone]) {
            trackedMilestones[milestone] = true;
            self.track('scroll_milestone', {
              depth_percent: milestone,
              time_to_reach_ms: Date.now() - self.data.sessionStart
            });
          }
        });
      }, 200);

      window.addEventListener('scroll', trackScroll, { passive: true });

      // 追踪最终滚动深度
      window.addEventListener('beforeunload', function() {
        self.track('max_scroll_depth', {
          depth_percent: maxScrollDepth,
          session_duration_ms: Date.now() - self.data.sessionStart
        });
      });

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Scroll milestone tracking setup');
      }
    },

    /**
     * 发送汇总数据（页面离开时）
     */
    sendSummaryData: function() {
      var sessionDuration = Date.now() - this.data.sessionStart;
      
      // 发送 Hero 轮播汇总
      if (this.config.enableTimeEvents && Object.keys(this.data.heroSlideViews).length > 0) {
        this.track('hero_slides_summary', {
          slide_view_times: this.data.heroSlideViews,
          session_duration_ms: sessionDuration
        });
      }

      // 发送 Section 停留时间汇总
      if (this.config.enableTimeEvents && Object.keys(this.data.sectionTimes).length > 0) {
        // 找出停留时间最长的 section
        var topSections = Object.entries(this.data.sectionTimes)
          .sort(function(a, b) { return b[1] - a[1]; })
          .slice(0, 5);
        
        this.track('section_times_summary', {
          section_times: this.data.sectionTimes,
          top_sections: topSections.map(function(s) { return { id: s[0], time_ms: s[1] }; }),
          session_duration_ms: sessionDuration
        });
      }

      // 发送 Tab 点击汇总
      if (Object.keys(this.data.tabClicks).length > 0) {
        this.track('tab_clicks_summary', {
          tab_clicks: this.data.tabClicks,
          session_duration_ms: sessionDuration
        });
      }

      // 发送 FAQ 展开汇总
      if (Object.keys(this.data.faqExpands).length > 0) {
        this.track('faq_expands_summary', {
          faq_expands: this.data.faqExpands,
          total_expands: Object.values(this.data.faqExpands).reduce(function(a, b) { return a + b; }, 0),
          session_duration_ms: sessionDuration
        });
      }

      if (this.config.debug) {
        console.log('[EnhancedAnalytics] Summary data sent');
      }
    },

    /**
     * 开启调试模式
     */
    enableDebug: function() {
      this.config.debug = true;
      console.log('[EnhancedAnalytics] Debug mode enabled');
      console.log('[EnhancedAnalytics] Current data:', this.data);
    }
  };

  // 初始化
  EnhancedAnalytics.init();

  // 暴露到全局
  window.EnhancedAnalytics = EnhancedAnalytics;
})();
